<template>
	<div id="rootVM" v-cloak>
		<div id="pageTitle">
			<b>공통코드관리</b>
		</div>
		<!-- Search -->
		<div class="panel panel-flat">
			<!-- <div class="panel-heading">
				<h6 class="panel-title">
					<i class="icon-search4 position-left"></i>
					<b>검색조건</b>
				</h6>
				<div class="heading-elements">
					<ul class="icons-list">
						<li><a @click="pannelHidden" data-action="collapse"></a></li>
					</ul>
				</div>
			</div> -->
			<div class="panel-body" style="width: 1250px; margin: 20px 0px 0px auto">
				<form action="#" @submit.prevent="search">
					<div class="row">
						<div class="col-md-2" style="width: 275px">
							<div class="form-group">
								<label style="width: 60px">{{ detailsFieldMap.grpCd }}</label>
								<input
									id="startInput"
									type="text"
									class="form-control"
									:placeholder="detailsFieldMap.grpCd"
									v-model="searchVM.grpCd"
									:maxlength="maxLength.grpCd"
								/>
							</div>
						</div>
						<div class="col-md-2" style="width: 200px">
							<div class="form-group">
								<label>{{ detailsFieldMap.cd }}</label>
								<input
									type="text"
									class="form-control"
									style="width: 100px"
									:placeholder="detailsFieldMap.cd"
									v-model="searchVM.cd"
									:maxlength="maxLength.cd"
								/>
							</div>
						</div>
						<div class="col-md-2" style="width: 270px">
							<div class="form-group">
								<label>{{ detailsFieldMap.cdNm }}</label>
								<input
									type="text"
									class="form-control"
									style="width: 150px"
									:placeholder="detailsFieldMap.cdNm"
									v-model="searchVM.cdNm"
									:maxlength="maxLength.cdNm"
								/>
							</div>
						</div>
						<div class="col-md-2" style="width: 290px">
							<div class="form-group">
								<label>{{ detailsFieldMap.cdVal }}</label>
								<input type="text" class="form-control" :placeholder="detailsFieldMap.cdVal" v-model="searchVM.cdVal" :maxlength="maxLength.cdVal" />
							</div>
						</div>
						<div class="mb-10 text-right">
							<button type="submit" class="btn btn-labeled bg-primary">
								<b><i class="icon-search4"></i></b>
								검색
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>

		<!-- Grid -->
		<div>
			<div class="mb-10 text-right">
				<button type="button" class="btn btn-labeled bg-teal mx-sm-1" @click="downloadExcel">
					<b><i class="icon-file-excel"></i></b>
					엑셀다운로드
				</button>
				<!-- 			<button type="button" class="btn btn-labeled bg-danger" @click="startCreate"><b><i class="icon-minus3"></i></b> 삭제</button> -->
				<button type="button" class="btn btn-labeled bg-primary" @click="startCreate">
					<b><i class="icon-plus3"></i></b>
					추가
				</button>
			</div>

			<KendoGrid
				ref="grid"
				:auto-bind="true"
				:api-url="apiUrl.pageListApi"
				:columns="gridColumns"
				:apply-search-condition="applySearchStateOnGridLoad"
				@selected-row-item-changed="selectedRowItemChanged"
			></KendoGrid>

			<div class="mt-10 mb-15 text-right"></div>
		</div>

		<!-- Details -->
		<form id="detailsForm" action="#" class="form-horizontal form-validate-jquery" v-show="isEditMode || isCreateMode">
			<div class="panel panel-flat">
				<div class="panel-heading">
					<h6 class="panel-title">
						<i class="icon-checkmark3 position-left"></i>
						<b>상세정보</b>
					</h6>
					<div class="heading-elements">
						<ul class="icons-list">
							<li><a @click="pannelHidden" data-action="collapse"></a></li>
						</ul>
					</div>
				</div>
				<div class="panel-body panel-body-center">
					<div class="row panel-detail">
						<fieldset>
							<legend class="text-semibold col-md-12">
								<i class="icon-cog3 position-left"></i>
								공통코드관리 정보
							</legend>
							<div class="col-md-6 inputDiv1">
								<!-- 그룹 코드. 생성시 필수, 수정시 변경불가 -->
								<jarvis-field :label="detailsFieldMap.grpCd" :required="true" field="detailsItem.grpCd">
									<select2
										v-model="detailsItem.grpCd"
										:options="detailsOptions.grpCdOptions"
										:disabled="!isCreateMode"
										data-vv-name="detailsItem.grpCd"
										v-validate="validationRule.detailsItem.grpCd"
									>
										<option value="">선택</option>
									</select2>
								</jarvis-field>
								<!-- 공통코드.  필수 -->
								<jarvis-field
									:label="detailsFieldMap.cd"
									required="true"
									:disabled="!isCreateMode"
									id="firstInputCreate"
									field="detailsItem.cd"
									v-model="detailsItem.cd"
									data-vv-name="detailsItem.cd"
									v-validate="validationRule.detailsItem.cd"
									:maxLength="maxLength.cd"
								></jarvis-field>
								<!-- 공통코드명. 필수 -->
								<jarvis-field
									:label="detailsFieldMap.cdNm"
									required="true"
									id="firstInputEdit"
									field="detailsItem.cdNm"
									v-model="detailsItem.cdNm"
									data-vv-name="detailsItem.cdNm"
									v-validate="validationRule.detailsItem.cdNm"
									:maxLength="maxLength.cdNm"
								></jarvis-field>
								<!-- 공통 코드 값. -->
								<jarvis-field
									:label="detailsFieldMap.cdVal"
									field="detailsItem.cdVal"
									v-model="detailsItem.cdVal"
									data-vv-name="detailsItem.cdVal"
									v-validate="validationRule.detailsItem.cdVal"
									:maxLength="maxLength.cdVal"
								></jarvis-field>
								<!-- 공통 코드 설명. -->
								<!-- <jarvis-field
									:label="detailsFieldMap.cdDscr"
									field="detailsItem.cdDscr"
									v-model="detailsItem.cdDscr"
									data-vv-name="detailsItem.cdDscr"
									v-validate="validationRule.detailsItem.cdDscr"
								></jarvis-field> -->
								<!-- 공통 코드 설명. -->
								<div class="row col-md-12" style="margin-left: 0px; padding-right: 0px">
									<label class="col-md-3 title" style="text-align: center; margin-top: 8px; padding: 0px">{{ detailsFieldMap.cdDscr }}:</label>
									<div class="col-md-9" style="padding: 0px">
										<textarea
											class="form-control"
											rows="3"
											cols="40"
											v-model="detailsItem.cdDscr"
											field="detailsItem.cdDscr"
											data-vv-name="detailsItem.cdDscr"
											style="resize: none"
											:maxlength="maxLength.cdDscr"
										></textarea>
									</div>
								</div>
							</div>

							<div class="col-md-6">
								<!-- 등록일, 수정모드만 표시 -->
								<jarvis-field
									:label="detailsFieldMap.regDtm"
									disabled="true"
									v-if="isEditMode"
									field="detailsItem.regDtm"
									:value="detailsItem.regDtm | toDisplayDateTime"
								></jarvis-field>
								<!-- 등록자, 수정모드만 표시 -->
								<jarvis-field
									:label="detailsFieldMap.regUser"
									disabled="true"
									v-if="isEditMode"
									field="detailsItem.regUser"
									:value="detailsItem.regUser"
								></jarvis-field>
								<!-- 수정일, 수정모드만 표시 -->
								<jarvis-field
									:label="detailsFieldMap.updDtm"
									disabled="true"
									v-if="isEditMode"
									field="detailsItem.updDtm"
									:value="detailsItem.updDtm | toDisplayDateTime"
								></jarvis-field>
								<!-- 수정자, 수정모드만 표시 -->
								<jarvis-field
									:label="detailsFieldMap.updUser"
									disabled="true"
									v-if="isEditMode"
									field="detailsItem.updUser"
									:value="detailsItem.updUser"
								></jarvis-field>
							</div>
						</fieldset>
					</div>
					<div class="text-right" v-if="!isEditMode">
						<button type="button" class="btn btn-labeled mx-sm-1" @click="closeDetails">
							<b><i class="icon-cross"></i></b>
							닫기
						</button>
						<button type="button" class="btn btn-labeled bg-primary" @click="createData">
							<b><i class="icon-checkmark3"></i></b>
							저장
						</button>
					</div>
					<div class="text-right" v-if="isEditMode">
						<button type="button" class="btn btn-labeled mx-sm-1" @click="closeDetails">
							<b><i class="icon-cross"></i></b>
							닫기
						</button>
						<button type="button" class="btn btn-labeled bg-warning mx-sm-1" @click="deleteData">
							<b><i class="icon-minus3"></i></b>
							삭제
						</button>
						<button type="button" class="btn btn-labeled bg-primary" @click="updateData">
							<b><i class="icon-checkmark3"></i></b>
							저장
						</button>
					</div>

					<span v-if="debug">
						isCreateMode: {{ isCreateMode }}
						<br />
						isEditMode: {{ isEditMode }}
						<br />
						detailsItemOriginal: {{ detailsItemOriginal }}
						<br />
						detailsItem: {{ detailsItem }}
						<br />
						errors: {{ errors }}
						<br />
					</span>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import KendoGrid from '@/components/KendoGrid';
import Select2 from '@/components/Select2';
import _ from 'lodash';
import JarvisField from '@/components/JarvisField';
import apiIndex from '../../api/index';

let axiosExtention; //eslint-disable-line no-unused-vars

const commCodeApi = apiIndex.commCode;

//상세필드검증규칙
const detailsValidationRule = {
	common: {
		//공통
		grpCd: 'max:100|required',
		cd: 'max:100|required',
		cdNm: 'max:500|required',
		cdDscr: 'max:1000',
		cdVal: 'max:100',
	},
	edit: {
		//수정
	},
	create: {
		//생성
	},
};

const maxLength = {
	grpCd: '100',
	cd: '100',
	cdNm: '500',
	cdDscr: '1000',
	cdVal: '100',
};

_.extend(detailsValidationRule.edit, detailsValidationRule.common);
_.extend(detailsValidationRule.create, detailsValidationRule.common);

export default {
	components: {
		select2: Select2,
		'jarvis-field': JarvisField,
		KendoGrid: KendoGrid,
	},
	created() {
		let params = JSON.parse(sessionStorage.getItem('commCodePageParam'));
		if (!params) location.href = apiIndex.mainUrl;
		this.detailsOptions = {
			grpCdOptions: params.grpCdOptions,
		};
		this.searchOptions = {
			grpCdOptions: this.detailsOptions.grpCdOptions,
		};
		this.$validator.localize('ko', { attributes: this.$jarvisExtention.addKeyPrefix(this.detailsFieldMap, 'detailsItem.') });
		axiosExtention = this.$jarvisExtention.axiosExtention;
	},
	mounted() {
		this.$nextTick(function () {
			this.focusFirstInput('startInput');
		});
	},
	data: () => ({
		//API목록
		apiUrl: {
			excelApi: commCodeApi.exlCommCode,
			pageListApi: commCodeApi.inqCommCode,
			detailsApi: commCodeApi.inqOneCommCode,
			delApi: commCodeApi.delCommCode,
			updateApi: commCodeApi.updCommCode,
			insApi: commCodeApi.commCode,
		},
		//검색VM
		searchVM: {
			grpCd: '',
			cd: '',
			cdNm: '',
			cdVal: '',
		},
		//상세 select options
		detailsOptions: {
			grpCdOptions: '',
		},
		//적용된 검색조건
		searchState: {},
		//검색VM-Select옵션
		searchOptions: {},
		//그리드설정
		gridColumns: [
			{ field: 'grpCd', title: '그룹 코드', width: '20%' },
			{ field: 'cd', title: '공통 코드', width: '10%' },
			{ field: 'cdNm', title: '공통 코드 명', width: '20%' },
			{ field: 'cdVal', title: '공통 코드 값', width: '10%' },
			{ field: 'cdDscr', title: '공통코드설명', width: '20%', overFlowHidden: true },
			{ field: 'regDtm', title: '등록일', dataFormat: 'YYYY-MM-DD', width: '10%', align: 'center' },
			{ field: 'updDtm', title: '수정일', dataFormat: 'YYYY-MM-DD', width: '10%', align: 'center' },
		],
		//상세필드명맵
		detailsFieldMap: {
			grpCd: '그룹 코드',
			cd: '공통 코드 ',
			cdNm: '공통 코드 명',
			cdDscr: '공통코드설명',
			cdVal: '공통 코드 값',
			regDtm: '등록일',
			regUser: '등록자',
			updDtm: '최종 수정일',
			updUser: '최종 수정자',
		},
		//인풋값의 최대 길이
		maxLength,
		//상세편집 원본
		detailsItemOriginal: {},
		//상세편집 수정본
		detailsItem: {},
		debug: false,
	}),
	computed: {
		isEditMode() {
			return !_.isEmpty(this.detailsItem) && !_.isEmpty(this.detailsItemOriginal);
		},
		isCreateMode() {
			return !_.isEmpty(this.detailsItem) && _.isEmpty(this.detailsItemOriginal);
		},
		validationRule() {
			var rule = null;
			if (this.isEditMode) {
				if (this.detailsItem.isChangePassword) {
					rule = $.extend(true /*deep*/, { password: 'required|min:4|max:20' }, detailsValidationRule.edit);
				} else {
					rule = detailsValidationRule.edit;
				}
			} else {
				rule = detailsValidationRule.create;
			}
			return { detailsItem: rule };
		},
	},
	watch: {
		detailsItem(newVal) {
			this.$validator.reset(); //Validation상태 초기화
			//details활성화 시 스크롤 이동처리
			if (!_.isEmpty(newVal)) {
				this.$nextTick(function () {
					window.scrollTo({ top: this.getDetailsFormPositionForScrolling(), behavior: 'smooth' });
				});
			}
		},
		isCreateMode() {
			let element = document.getElementsByClassName('inputDiv1')[0];
			if (this.isCreateMode) {
				element.classList.add('col-lg-offset-3');
			} else {
				element.classList.remove('col-lg-offset-3');
			}
			// for (let element in document.getElementsByClassName('inputDiv1')) {
			// 	if (this.isCreateMode) {
			// 		element.classList.add('col-lg-offset-3');
			// 	} else {
			// 		element.classList.remove('col-lg-offset-3');
			// 	}
			// }
		},
		'detailsItem.isChangePassword'(newVal, oldVal) {
			//EditMode에서의 toggle인 경우만 실행
			if (!_.isUndefined(newVal) && !_.isUndefined(oldVal)) {
				this.$validator.reset(); //Validation상태 초기화
				this.$validator.validateAll(); //Validation상태 검사
			}
		},
	},
	methods: {
		getDetailsFormPositionForScrolling() {
			let element = document.getElementById('detailsForm');
			return element.getBoundingClientRect().top + window.scrollY;
		},
		pannelHidden(e) {
			// click event 에서 target pannel 가져오기
			let pannel = $(e.target).closest('.panel').find('.panel-body')[0];
			if (pannel) {
				if (pannel.style.display === 'none') {
					e.target.classList.remove('rotate-180');
					pannel.style.display = 'block';
				} else {
					e.target.classList.add('rotate-180');
					pannel.style.display = 'none';
				}
			}
		},
		//검색적용
		search() {
			this.searchState = $.extend(true /*deep*/, {}, this.searchVM);
			this.loadGrid();
		},
		//그리드로드
		loadGrid() {
			this.closeDetails();
			this.$refs.grid.load();
		},
		//그리드로드시 검색조건적용
		applySearchStateOnGridLoad(param) {
			return $.extend(true /*deep*/, param, this.searchState || {});
		},
		//엑셀다운로드
		downloadExcel() {
			this.$axios({
				url: this.apiUrl.excelApi,
				method: 'POST',
				responseType: 'blob', // important
				data: this.searchState,
			})
				.then(response => {
					let date = new Date();
					// 저장 파일 명 생성
					let fileName = '공통코드관리_' + date.getFullYear() + ('0' + (1 + date.getMonth())).slice(-2) + ('0' + date.getDate()).slice(-2) + '.xlsx';
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', fileName);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				})
				.catch(axiosExtention.buildErrorHandler());
		},
		//그리드선택처리
		selectedRowItemChanged(selectedRowItem) {
			if (!_.isEmpty(selectedRowItem)) {
				//수정시작
				this.$axios
					.post(this.apiUrl.detailsApi, { grpCd: selectedRowItem.grpCd, cd: selectedRowItem.cd })
					.then(
						function (response) {
							this.detailsItemOriginal = $.extend(true /*deep*/, {}, response.data);
							this.detailsItem = $.extend(true /*deep*/, {}, response.data);
							setTimeout(() => this.focusFirstInput('firstInputEdit'), 500);
						}.bind(this),
					)
					.catch(axiosExtention.buildErrorHandler());
			} else {
				//상세화면 닫기 (다시로드등으로 선택변경)
				this.closeDetails();
			}
		},
		//상세화면 닫기
		closeDetails() {
			this.detailsItemOriginal = {};
			this.detailsItem = {};
		},
		openDetails() {
			this.detailsItemOriginal = {};
			this.detailsItem = {
				grpCd: '',
				cd: '',
				cdNm: '',
				cdDscr: '',
				cdVal: '',
			};
		},
		//데이터 추가 시작
		startCreate() {
			this.openDetails();
			setTimeout(() => this.focusFirstInput('firstInputCreate'), 500);
		},
		focusFirstInput(inputId) {
			document.getElementById(inputId).focus();
		},
		//데이터 수정 시작
		startEdit(cd) {
			const closure = this;
			this.$axios
				.get(closure.apiUrl.pageListApi + '/' + cd)
				.then(function (response) {
					closure.detailsItemOriginal = $.extend(true /*deep*/, {}, response.data);
					closure.detailsItem = $.extend(true /*deep*/, {}, response.data);
				})
				.catch(axiosExtention.buildErrorHandler());
		},
		//신규저장
		createData() {
			const closure = this;
			this.$validator.validateAll().then(function (success) {
				if (success == false) {
					// console.log('validation.errors: ', closure.errors);
					return;
				}
				closure.$axios
					.post(closure.apiUrl.insApi, closure.detailsItem)
					.then(function (response) {
						response;
						closure.loadGrid();
					})
					.catch(axiosExtention.buildErrorHandler(closure.detailsFieldMap));
			});
		},
		//수정저장
		updateData() {
			const closure = this;
			this.$validator.validateAll().then(function (success) {
				if (success == false) {
					// console.log('validation.errors: ', closure.errors);
					return;
				}
				// if (this.errorCompanyNm.length) return;
				if (confirm('수정한 데이터를 저장하시겠습니까?')) {
					closure.$axios
						.post(closure.apiUrl.updateApi, closure.detailsItem)
						.then(
							function (response) {
								response;
								closure.loadGrid();
							}.bind(closure),
						)
						.catch(axiosExtention.buildErrorHandler(closure.detailsFieldMap));
				}
			});
		},
		//삭제
		deleteData() {
			if (!confirm('해당 데이터를 영구적으로 삭제하시겠습니까?')) {
				return;
			}
			this.$axios
				.post(this.apiUrl.delApi, { grpCd: this.detailsItem.grpCd, cd: this.detailsItem.cd })
				.then(
					function () {
						this.loadGrid();
					}.bind(this),
				)
				.catch(axiosExtention.buildErrorHandler(this.detailsFieldMap));
		},
	},
};
</script>

<style scoped>
[v-cloak] > * {
	display: none !important;
}
#rootVM > .panel .panel-body .form-group {
	display: flex;
	align-items: center;
}
#rootVM > .panel .panel-body .form-group label {
	width: 50%;
	margin-top: 5px;
}
#rootVM > .panel .panel-body .form-group input {
	max-width: 180px;
	margin-left: 15px;
}
label {
	text-align: right;
}
</style>
